import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, TextField, Stack } from '@mui/material';

const periods = [
  { value: '1m', label: '1m' },
  { value: '3m', label: '3m' },
  { value: '6m', label: '6m' },
  { value: '12m', label: '12m' },
  { value: 'custom', label: 'Custom' },
];

export default function FilterBar({
  activeTab,
  filters,
  onChange,
  companies,
  industries,
  organizations,
  showOrganizationSelector = true,
}) {
  const handleChange = (key) => (e) => onChange({ ...filters, [key]: e.target.value });

  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems="center" sx={{ mb: 2 }}>
      {/* Period */}
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel>Period</InputLabel>
        <Select label="Period" value={filters.period} onChange={handleChange('period')}>
          {periods.map((p) => (
            <MenuItem key={p.value} value={p.value}>{p.label}</MenuItem>
          ))}
        </Select>
      </FormControl>

      {filters.period === 'custom' && (
        <>
          <TextField
            size="small"
            type="date"
            label="Start"
            InputLabelProps={{ shrink: true }}
            value={filters.startDate || ''}
            onChange={handleChange('startDate')}
          />
          <TextField
            size="small"
            type="date"
            label="End"
            InputLabelProps={{ shrink: true }}
            value={filters.endDate || ''}
            onChange={handleChange('endDate')}
          />
        </>
      )}

      {/* Organization */}
      {activeTab === 'organization' && showOrganizationSelector && (
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel>Organization</InputLabel>
          <Select label="Organization" value={filters.orgId || ''} onChange={handleChange('orgId')}>
            {organizations?.map((org) => (
              <MenuItem key={org.id} value={org.id}>{org.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Ask Tab Organization Selector */}
      {activeTab === 'ask' && showOrganizationSelector && (
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel>Organization</InputLabel>
          <Select label="Organization" value={filters.orgId || ''} onChange={handleChange('orgId')}>
            {organizations?.map((org) => (
              <MenuItem key={org.id} value={org.id}>{org.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Industry */}
      {activeTab === 'industry' && (
        <>
          <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel shrink>Industry</InputLabel>
            <Select
              label="Industry"
              value={filters.industry || ''}
              onChange={handleChange('industry')}
              displayEmpty
              notched
            >
              <MenuItem value="">All</MenuItem>
              {industries.map((i) => (
                <MenuItem key={i} value={i}>{i}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {showOrganizationSelector && (
            <FormControl size="small" sx={{ minWidth: 180 }}>
              <InputLabel shrink>Organization</InputLabel>
              <Select
                label="Organization"
                value={filters.orgId || ''}
                onChange={handleChange('orgId')}
                displayEmpty
                notched
              >
                <MenuItem value="">All Organizations</MenuItem>
                {organizations?.map((org) => (
                  <MenuItem key={org.id} value={org.id}>{org.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </>
      )}
    </Stack>
  );
}
